import React, {useState, useEffect} from 'react';
import {
  useHistory
} from "react-router-dom";
import {
  ResourceList,
  Thumbnail,
  ResourceItem,
  TextStyle,
  Page,
  Card,
  SkeletonBodyText,
  Stack,
  Button, Icon, Toast, Frame
} from '@shopify/polaris';
import {DeleteMinor, ImportMinor, ViewMinor} from '@shopify/polaris-icons';
import {productService} from '../services/product';

interface AccountProps {
  onAction(): void;
}

export default function Home(props: any) {

  const [isSyncingProducts, setIsSyncingProducts] = useState(false);
  const [productSyncStatus, setProductSyncStatus] = useState('');
  const [productGroups, setProductGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isToastActive, setIsToastActive] = useState(false);
  const history = useHistory();
  
  const syncProducts = () => {
    setIsSyncingProducts(true);
    productService.sync().then( (data) => {
      const { job_id } = data;
      if(job_id) {
        // SSE - sever sent events init
        const source = new EventSource(`/api/sync/status?clientId=${job_id}`);

        source.addEventListener('syncUpdate', (message: any) => {
          //const { data } = message;
          const { status } = JSON.parse(message.data);
          if( status != 'pending' ) {
            setIsSyncingProducts(false);
            setIsToastActive(true);
            source.close();
            setProductSyncStatus(status);
          }
        });

        source.onmessage = e => {
          console.log('on message', e);
        }
        source.onerror = () => {
          // error log here
          console.log('on error');
          setIsSyncingProducts(false);
          source.close();
        }
      }
    });

  };

  const primaryAction = {content: 'New Group', url: '/product-group/new'};
  const secondaryActions = [
    {content: 'Sync Products', icon: ImportMinor, loading: isSyncingProducts, onAction: syncProducts}
  ];

  useEffect(() => {
    productService.groups().then(products => {
      setProductGroups(products);
      setIsLoading(false);
    })
  }, []);

  const removeProductGroup = (id: any, handle: string) => {
    return function remove(){
      console.log(id, productGroups.filter(item => id === item['id']));
      setProductGroups(productGroups.filter(item => id !== item['id']));
      productService.removeGroup(handle).then(() => {
      });
    }
  }

  const toastMarkup: any = isToastActive && productSyncStatus != '' ? (<Toast content={'Sync ' + productSyncStatus} onDismiss={() => { setIsToastActive(false); }} error={productSyncStatus == 'failed' ? true : false} />) : null;

  return (
    <Frame>
      <Page
        title="Product Groups"
        //breadcrumbs={breadcrumbs}
        primaryAction={primaryAction}
        secondaryActions={secondaryActions}
      >
      <Card sectioned>
        {isLoading ? (<SkeletonBodyText lines={3} />) : (
          <ResourceList
            resourceName={{singular: 'product', plural: 'products'}}
            items={productGroups}
            renderItem={(item) => {
              const {id, title, image, variants, handle}: any = item;
              const media = (<Thumbnail source={image.src} alt={title} />);

              return (
                <ResourceItem
                  id={id}
                  onClick={(e) => {
                  }}
                  media={media}
                  accessibilityLabel={`View details for ${title}`}
                >
                  <Stack alignment="center">
                    <Stack.Item fill>
                    <h3><TextStyle variation="strong">{title}</TextStyle></h3><div>{variants.length} variants</div>
                    </Stack.Item>
                    <Stack.Item>
                    <Button icon={(<Icon source={ViewMinor} />)} size="slim" onClick={() => {
                      history.push(`/product/${handle}`);
                    }}></Button>
                    <Button destructive icon={(<Icon source={DeleteMinor} />)} size="slim" onClick={removeProductGroup(id, handle)}></Button>
                    </Stack.Item>
                  </Stack>
                </ResourceItem>
              )
            }}
          />
        )}
      </Card>
      {toastMarkup}
    </Page>
  </Frame>
  );
}
